<template>
    <div class="d-inline-flex">
        <b-img
            :src="image"
            width="32px"
            height="32px"
            alt="Icône"
            @error="$event.target.src = (defaultImage || DEFAULT_IMAGE)"
            :rounded="imageRounded"
        />
        <div class="pl-2">
            <slot>{{ content }}</slot>
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE } from '@/utils/constants'

export default {
    name: 'simple-card',
    props: {
        image: String,
        defaultImage: String,
        imageRounded: String,
        content: String
    },
    data: () => ({
        DEFAULT_IMAGE
    })
}
</script>